export const imageTypes = [
  'image/jpeg',
  'image/png',
];
export const videoTypes = [
  'video/mp4',
  'video/webm',
];

export const applicationTypes = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.oasis.opendocument.text',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.oasis.opendocument.presentation',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.oasis.opendocument.spreadsheet',
];

export const relatedResourceTypes = [
  'event', 'feed', 'offer', 'profile', 'bank',
] as const;

export const attachmentTypes = { imageTypes, videoTypes, applicationTypes };
